import PubSub from "underpub-js";

var RichText = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-RichText',
	};

	$.extend(true, this.options, options);

};

RichText.prototype.init = function() {

	var self = this;

};

export default RichText;
